import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'kpa-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
	@Input() dialogOpened: boolean = false;
	@Input() employeeId: number;
	@Output() dialogOpenedChange: EventEmitter<number> = new EventEmitter<number>();
	@Output() closeDialog = new EventEmitter();
	constructor() {}

	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public resendCredentials(employeeId: number) {
		this.dialogOpenedChange.emit(employeeId);
		this.dialogOpened = false;
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.closeDialog.emit();
	}
}
